import Config from '../config'
var OnlineUploader = require('@albelli/online-uploader').Uploader;

// Shared so the main uploader and the preview uploader (preview-uploader.js) are configured identically.
function createUploaderOptions() {
    return {
        applicationName: "Prints Editor", //Name of app that uses the uploader
        applicationVersion: "{version}", //Version of app that uses the uploader
        storageApiUrl: Config.UploadRegistrationApi, //Url to the storage api
        parallellUploads: Config.UploadSettings.parallel, //Maximum number of parallel uploads
        iframeBasePath: "./assets/iframes", //Where are the worker iframes
        sessionId: sessionStorage.getItem('sessionId'), //App session id
        s3UrlMapperRegex: Config.photoUpload.regex, //Some aws urls get too long and we have to remap them to make them shorter
        uploadIfDuplicate: true, //Checks if image already has been uploaded within the current sessionId
        token: "", //If you specify a token then the images will be asociated with the user. Token can be ecom or photoorganiser. If ecom it must have the scopes "storage.upload.write" and "storage.upload.read"
        channel: sessionStorage.getItem("channel"), //Channel
        allowedMimeTypes: Config.UploadSettings.mimeTypes, //Allowed mime types
        allowUploadProgressiveJpeg: true, //Does progressive JPEG is allowed?
        maxFileSize: Config.UploadSettings.maxFileSize, //Maximum image size for upload
        maxPhotoPixels: Config.UploadSettings.maxPhotoPixels, //Maximum image dimensions for upload
        profile: false, //Profiling the app
        retry: Config.UploadSettings.retry,
        validation: {
            enabled: true,
            config: {
                jpg: { validateICC: true }
            }
        }
    };
}

// Build a fresh uploader instance (main singleton below + the isolated preview uploader).
export function createUploader() {
    return new OnlineUploader(createUploaderOptions());
}

/**
 * This creates a Singleton instance of the uploader, so that I can easily have the same instance on multiple places in the app
 */
var uploader = createUploader();

export default uploader;
